export default {

  //展示owner数据
  getOwnerData: "/dashboard/operatingStatement/owner/aggregate",
// 展示prop数据
 getPropTableList:"/dashboard/operatingStatement/prop/aggregate",
// 展示卡片数据
getCardData:"/dashboard/operatingStatement/yoy",
// 获取银行余额信息
getBankBalanceSummaryList:"/dashboard/bankBalanceSummary/show",
// 展示当前分组列表
getBalanShowGroupList:"/dashboard/bankBalanceSummary/showGroupList",
// 修改当前分组
getUpdateBalanGroupList:"/dashboard/bankBalanceSummary/updateGroup",
// 删除分组
getDeleteBalanGroupList:"/dashboard/bankBalanceSummary/deleteGroup",
// 增加分组
getAddGroupList:"/dashboard/bankBalanceSummary/addGroup",
// 获取更新日期
getUpdateTime:"/dashboard/operatingStatement/getUpdateTime",
// 获取一周的数据
getRpsShowWeek:"/dashboard/rpsFileDailyDeposit/showWeek",
// 获取前4周的数据
getRPSShowWeekInit:"/dashboard/rpsFileDailyDeposit/showWeekInit",
// 点击获取后面的数据
getRPSShowWeekMore:"/dashboard/rpsFileDailyDeposit/showWeekMore",
// 获取年数据量环比
getRPSShowYear:"/dashboard/rpsFileDailyDeposit/showYear",
// 点击获取金额详情
getTotalAmountShow:"/dashboard/rpsFileDailyDeposit/showTypeAmount",
// 获取前四周 Trans数据
getShowTntTransWeekInit:"/dashboard/rpsFileDailyDeposit/showTntTransWeekInit",
// 点击获取后面的Trans 数据
getShowTntTransWeekMore:"/dashboard/rpsFileDailyDeposit/showTntTransWeekMore",
// 导出报表数据
getMortgageExportExcel:"/dashboard/mortgageCheck/exportExcel",
// 上传数据
getMortgageImportExcel:"/dashboard/mortgageCheck/importExcel",
// 展示空值 列表
getSnapshotShow:"/dashboard/unitVacancySnapshot/showSnapshot",
// 展示空置值 -City
getSnapshotByCity:"/dashboard/unitVacancySnapshot/showVacancyByCity",
// 展示空置值 -Area
getSnapshotByArea:"/dashboard/unitVacancySnapshot/showVacancyByArea",
// 展示空置值 -Supervisor
getSnapshotBySupervisor:"/dashboard/unitVacancySnapshot/showVacancyBySupervisor",
// 展示空置值 -Unit详情
getSnapshotByUnit:"/dashboard/unitVacancySnapshot/showVacancyDetail",
// 展示空置历史记录
getShowVacancyHistory:"/dashboard/unitVacancySnapshot/showVacancyHistory",
// 空置Prop 详情
getSnapshotByProperty:"/dashboard/unitVacancySnapshot/showPropertyDetail"
};
